'use strict';

export default {
  modalComponent: {
    action: {
      cancel: 'Cancel',
      submit: 'Submit',
    },
  },
};
